export default __webpack_public_path__ + "static/media/coconut_alone.730c077a.png";